import React from 'react';
import { Box, Card, Text, Title } from '@mantine/core'
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth';

import { Shield, AlertTriangle } from 'lucide-react';

interface SuperAdminGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const SuperAdminGuard: React.FC<SuperAdminGuardProps> = ({ 
  children, 
  fallback 
}) => {
  const { user, isAuthenticated } = useAuth();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If not a superuser, show access denied
  if (!user?.is_superuser) {
    if (fallback) {
      return <>{fallback}</>;
    }

    return (
      <Box mih="100vh" display="flex" style={{alignItems:'center',justifyContent:'center',backgroundColor:'var(--mantine-color-body)'}}>
        <Card withBorder padding="lg" w="100%" maw={448}>
          <Box ta="center" p="1rem">
            <Box ml="auto" mr="auto" mb={16} h={48} w={48} display="flex" style={{alignItems:'center',justifyContent:'center',borderRadius:9999,backgroundColor:'var(--mantine-color-red-1)'}}>
              <Shield  style={{height:24,width:24,color:'var(--mantine-color-red-6)'}} />
            </Box>
            <Title order={4} fz="xl">Access Denied</Title>
            <Text size="sm" c="dimmed">
              This page requires superadmin privileges.
            </Text>
          </Box>
          <Box ta="center" p="0 1rem 1rem">
            <Box fz="sm" c="dimmed" mb={16} display="flex" style={{alignItems:'center',justifyContent:'center',gap:8}}>
              <AlertTriangle style={{height:16,width:16}} />
              <span>Superadmin access required</span>
            </Box>
            <Text component="p" fz="sm" c="dimmed">
              Please contact your administrator if you believe you should have access to this page.
            </Text>
          </Box>
        </Card>
      </Box>
    );
  }

  // If superuser, render children
  return <>{children}</>;
}; 